import registerPolicyModel from '../model/registerPolicyModel.js';
import {grantPolicyModel, grantRdonlyPolicyModel} from "../model/grantPolicyModel";
import revokePolicyModel from "../model/revokePolicyModel";
import { baseurl, clientID } from "../util/config";
import jwt_decode from "jwt-decode";
import SessionManager from './SessionManager';


const USER_MGMT_URL = baseurl + 'auth/realms/calyan/protocol/openid-connect/token'
const USER_INFO_URL = baseurl + `auth/admin/realms/calyan/users`
const USERS_URL = baseurl + 'auth/admin/realms/calyan/users/'
const LOGOUT_URL = baseurl + 'auth/realms/calyan/protocol/openid-connect/logout'
const DEVICE_URL = baseurl + 'api/2/search/things'

const REGISTER_POLICIES_URL = baseurl + 'api/2/policies/'
const REGISTER_DEVICE_URL = baseurl + 'api/2/things/'
const ERROR_MSG_500 = 'The request ran out of time to execute on the the back-end. Optimize your query and try again.';

/**
 * Common function to clear session and redirect to login
 * Used when authentication tokens are missing or invalid
 */
const clearSessionAndRedirect = () => {
    SessionManager.clearSession();
    if (typeof window !== 'undefined') {
        window.location.href = '/login';
    }
};

//#region Login

  //utility function to decode jwt access token
export  const parseJwt = (token) => {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );

    return JSON.parse(jsonPayload);
  };

/** POST call for login
 ReqBody - {username, password}
 */
export const handleLogin = async (username, password, otp='0') => {

    var details = {
        'client_id': 'dittoauth',
        'grant_type': 'password',
        'scope': 'openid',
        'username': username.trim(),
        'password': password.trim(),
        'totp': otp.trim()
    };

    var formBody = [];
    for (var property in details) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(details[property]);
        formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");

    const url = USER_MGMT_URL;

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        body: formBody
    };

    const result = await fetch(url, requestOptions);
    if (result.status === 400) {
        return 400;
    } else if (result.status === 401) {
        return 401;
    } else {
        const value = await result.json();
        //const decodedToken=jwt_decode(value.access_token)
        
        // Store clinician data securely
        // secureStorage.setItem("clinicianId", decodedToken.sub);
        // secureStorage.setItem("type", decodedToken.type);
        
        // Also store in localStorage for backward compatibility
        // localStorage.setItem("clinicianId", decodedToken.sub);
        // localStorage.setItem("type", decodedToken.type);
        
        // Set session - this will generate a new session ID and invalidate existing sessions
        SessionManager.setSession(value.access_token, value.refresh_token);
        
        // Broadcast new session to invalidate other tabs/windows
        import('./SessionInvalidationService').then(({ default: SessionInvalidationService }) => {
          const sessionId = SessionInvalidationService.getCurrentSessionId();
          if (sessionId) {
            SessionInvalidationService.broadcastNewSession(sessionId);
          }
        });
        
        return value;
    }
}

/** GET call for userinfo with self userid
 ReqBody - {refresh_token}
 */
export const getUserInfo = async (bearer_token) => {
    // Prefer userId from token 'sub' claim to avoid null localStorage
    let userId = '';
    try {
        const decoded = jwt_decode(bearer_token);
        userId = decoded?.sub || '';
    } catch (_) {
        // fallback to storage if decode fails
        userId = localStorage.getItem('clinicianId') || '';
    }

    if (!userId) {
        clearSessionAndRedirect();
        throw new Error('Missing userId: unable to resolve from token or storage. User logged out.');
    }

    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + bearer_token,
        },
       
    };
    const response = await fetch(`${USER_INFO_URL}/${userId}`, requestOptions);
    if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
    }
    const userInfo = await response.json();
    return userInfo
}

/** GET call for userinfo with another userid
 ReqBody - {refresh_token}
 */
 export const getUserInfoById = async(bearer_token, userId) => {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + bearer_token,
        },
       
    };
    const response = await fetch(`${USER_INFO_URL}/${userId}`, requestOptions);
    if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
    }
    const userInfo = await response.json();
    return userInfo
}

/** GET call for userinfo with usernname e.g emailId
 ReqBody - {refresh_token}
 */
 export const getUserInfoByName = async(bearer_token, emailId) => {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + bearer_token,
        },
       
    };
    const response = await fetch(`${USER_INFO_URL}?username=${encodeURIComponent(emailId)}`, requestOptions);
    if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
    }
    const userInfo = await response.json();
    return userInfo ? userInfo[0] : null;
}

/** POST call for refreshToken
 ReqBody - {refresh_token}
 */
export const handleRefreshToken = async (refresh_token) => {


    var details = {
        'client_id': 'dittoauth',
        'grant_type': 'refresh_token',
        'refresh_token': refresh_token
    };

    var formBody = [];
    for (var property in details) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(details[property]);
        formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");

    const url = USER_MGMT_URL;

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        body: formBody
    };

    const result = await fetch(url, requestOptions);

    if (result.status === 400) {
        return 400;
    } else if (result.status === 401) {
        // 401 indicates refresh token is invalid - likely due to concurrent login
        // This enforces single active session per user
        return 401;
    } else {
        const value = await result.json();
        return value;
    }
}

/** POST call for logout
 ReqBody - {userId}
 */
export const handleLogout = async (userId, refresh_token, bearer_token) => {

    const url = LOGOUT_URL;

    // Resolve tokens from parameters or session
    const token = bearer_token || SessionManager.getAccessToken();
    const refreshToken = refresh_token || SessionManager.getRefreshToken();
    if (!refreshToken || !token) {
        clearSessionAndRedirect();
        throw new Error('Missing tokens for logout. User logged out.');
    }

    const details = {
        'client_id': 'dittoauth',
        'refresh_token': refreshToken
    };

    let formBody = [];
    for (const property in details) {
        const encodedKey = encodeURIComponent(property);
        const encodedValue = encodeURIComponent(details[property]);
        formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            'Authorization': 'Bearer ' + token
        },
        body: formBody
    };

    const result = await fetch(url, requestOptions);
    if ((result.ok) && (result.status === 204)) {
        SessionManager.clearSession();
        return 204;
    } else {
        const value = await result.json();
        return value;
    }
}

//#endregion

//#region Registration

/*
 * PUT call for: Register Policy for device
*/
export const handleRegisterPolicy = async (macId, bearer_token) => {
    const decoded = parseJwt(bearer_token);
    const policyOwner = `calyan:${decoded.sub}`;
    const policyId = `pacemaker:${macId}-policy`;
    const url = REGISTER_POLICIES_URL + policyId;
    const subjectVal = {
        [policyOwner]:
            {
                "type": decoded.type
            }
    } 

    registerPolicyModel.policyId = policyId;
    registerPolicyModel.entries.DEFAULT.subjects = subjectVal;

    const requestOptions = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + bearer_token
        },
        body: JSON.stringify(registerPolicyModel)
    };
    const result = await fetch(url, requestOptions);
    if ((result.ok) && ((result.status === 204) || (result.status === 201))) {
        return true;
    } else {
        const value = await result.json();
        return value;
    }
}

/*
 * PUT call for: Register Policy for a thing (other than device)
*/
export const handleRegisterThingPolicy = async (identifier, bearer_token, policyowner='') => {

    const policyId = `${identifier}-policy`;
    const url = REGISTER_POLICIES_URL + policyId;
    registerPolicyModel.policyId = policyId;

    if(Object.keys(policyowner).length !== 0) {
        let ownerid=`calyan:${policyowner.userId}`;
        registerPolicyModel.entries.DEFAULT.subjects = {
            [ownerid]: {
                "type": policyowner.type
            }
        }
    }

    const requestOptions = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + bearer_token
        },
        body: JSON.stringify(registerPolicyModel)
    };
    const result = await fetch(url, requestOptions);
    if ((result.ok) && ((result.status === 204) || (result.status === 201))) {
        return true;
    } else {
        const value = await result.json();
        return value;
    }
}

/*
 * PUT call for: Register Device
*/
export const handleRegisterDevice = async (macId, model, bearer_token) => {
    //register policy
    const policyId = `pacemaker:${macId}-policy`;
    const resultPolicy = await handleRegisterPolicy(macId, bearer_token);

    if (resultPolicy === true) {
        const thingId = `pacemaker:${macId}`;
        const url = REGISTER_DEVICE_URL + thingId;
        model.thingId = thingId;
        model.policyId = policyId;

        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + bearer_token
            },
            body: JSON.stringify(model)
        }
        const result = await fetch(url, requestOptions);
        if ((result.ok) && ((result.status === 204) || (result.status === 201))) {
            return true;
        } else {
            const value = await result.json();
            return result.status === 400 ? ERROR_MSG_500 : value.errorMessage;
        }
    } else
        return resultPolicy;
}

/*
 * PUT call for: Register Thing (other than device)
*/
export const handleRegisterThing = async (identifier, model, bearer_token, policyowner={}) => {
    //register policy
    const policyId = `${identifier}-policy`;
    const resultPolicy = await handleRegisterThingPolicy(identifier, bearer_token, policyowner);

    if (resultPolicy === true) {
        const thingId = identifier;
        const url = REGISTER_DEVICE_URL + thingId;
        model.thingId = thingId;
        model.policyId = policyId;

        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + bearer_token
            },
            body: JSON.stringify(model)
        }
        const result = await fetch(url, requestOptions);
        if ((result.ok) && ((result.status === 204) || (result.status === 201))) {
            return true;
        } else {
            const value = await result.json();
            return result.status === 400 ? ERROR_MSG_500 : value.errorMessage;
        }
    } else
        return resultPolicy;
}

/*
 * Register Charger (thing type charger) — legacy direct Ditto registration
*/
export const handleRegisterCharger = async (macId, model, bearer_token) => {
    const decoded = parseJwt(bearer_token);
    const policyowner = { userId: decoded.sub, type: decoded.type };
    const identifier = `charger:${macId}`;
    return handleRegisterThing(identifier, model, bearer_token, policyowner);
}

// ── Charger Credentialing / Provisioning ─────────────────────────────────────
// These call the AdminUI Express backend (/api/v1/charger/*) which handles
// Keycloak client creation and Ditto provisioning feature management.

const CHARGER_API_URL = baseurl + 'api/v1/charger/';

/*
 * POST /api/v1/charger/register
 * Creates Keycloak client + Ditto thing with provisioning feature.
 * Returns { device_code, user_code, expires_in, interval } on success,
 * or { error } on failure.
*/
export const handleProvisionCharger = async (chargerMacId, chargerModel, chargerSerialNumber, firmwareVersion, bearer_token) => {
    const token = bearer_token || SessionManager.getAccessToken();
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify({ chargerMacId, chargerModel, chargerSerialNumber, firmwareVersion })
    };
    const result = await fetch(CHARGER_API_URL + 'register', requestOptions);
    const value  = await result.json();
    if (result.status === 201) return value;
    return { error: value.error || `Registration failed (${result.status})` };
}

/*
 * POST /api/v1/charger/verify
 * Admin confirms the physical charger. Sets provisioning.verified = true.
 * Returns { success: true } or { error }.
*/
export const handleVerifyCharger = async (user_code, bearer_token) => {
    const token = bearer_token || SessionManager.getAccessToken();
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify({ user_code })
    };
    const result = await fetch(CHARGER_API_URL + 'verify', requestOptions);
    if (result.status === 200) return { success: true };
    const value = await result.json();
    return { error: value.error || `Verification failed (${result.status})` };
}

/*
 * POST /api/v1/charger/pair
 * Records charger↔IPG relationship in Ditto and grants charger write on IPG policy.
 * Returns { success: true } or { error }.
*/
export const handlePairCharger = async (chargerMacId, ipgMacId, bearer_token) => {
    const token = bearer_token || SessionManager.getAccessToken();
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify({ chargerMacId, ipgMacId })
    };
    const result = await fetch(CHARGER_API_URL + 'pair', requestOptions);
    if (result.ok) return { success: true };
    const value = await result.json();
    return { error: value.error || `Pairing failed (${result.status})` };
}

/*
 * GET all charger things
*/
export const getAllChargers = async (bearer_token) => {
    const token = bearer_token || SessionManager.getAccessToken();
    if (!token) {
        clearSessionAndRedirect();
        throw new Error('No access token available for getAllChargers. User logged out.');
    }
    const url = DEVICE_URL + '?namespaces=charger';
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        }
    };
    const result = await fetch(url, requestOptions);
    if (!result.ok) throw new Error(`HTTP error: ${result.status}`);
    const value = await result.json();
    return value.items;
}

/*
 * GET a single charger thing by MAC ID.
 * Calls /api/2/things?ids=charger:<macId>
 * Returns the thing object or null if not found.
*/
export const getChargerByMacId = async (chargerMacId, bearer_token) => {
    const token = bearer_token || SessionManager.getAccessToken();
    if (!token) {
        clearSessionAndRedirect();
        throw new Error('No access token available for getChargerByMacId. User logged out.');
    }
    const url = REGISTER_DEVICE_URL + '?ids=charger:' + encodeURIComponent(chargerMacId);
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        }
    };
    const result = await fetch(url, requestOptions);
    if (!result.ok) return null;
    const value = await result.json();
    return (value && value.length > 0) ? value[0] : null;
}

// ── Charger Telemetry / Device Status ────────────────────────────────────────
// These read the latest snapshot stored in the Ditto charger thing by the
// AdminUI /api/v1/device/data and /api/v1/device/status routes.
// The charger uploads every 10 minutes; data reflects the most recent push.

const CHARGER_THING_URL = baseurl + 'api/2/things/';

/*
 * GET latest charger telemetry (implant battery, pod battery, NFC power, BLE/WLC flags).
 * Returns features/telemetry/properties from the Ditto charger:<macId> thing.
 * Fields: timestamp, implantBattery{adc,voltage}, podBattery{voltage},
 *         nfcPower, bleStatus{ble_connected,wlc_charging,aligned}, receivedAt
*/
export const getChargerTelemetry = async (chargerMacId, bearer_token) => {
    const token = bearer_token || SessionManager.getAccessToken();
    if (!token) {
        clearSessionAndRedirect();
        throw new Error('No access token available for getChargerTelemetry. User logged out.');
    }
    const url = `${CHARGER_THING_URL}charger:${chargerMacId}/features/telemetry/properties`;
    const result = await fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
    });
    if (!result.ok) throw new Error(`HTTP error: ${result.status}`);
    return result.json();
};

/*
 * GET latest charger device status (firmware version, WiFi info, RMS upload stats, NAND storage).
 * Returns features/deviceStatus/properties from the Ditto charger:<macId> thing.
 * Fields: timestamp, fwVersion, wifi{connected,rssi,ip},
 *         rmsStats{state,uploads,success,failures},
 *         storage{used_pct,throttled,bad_blocks},
 *         streamCounters{telemetry_dropped,telemetry_overwritten,protected_dropped}, receivedAt
*/
export const getChargerDeviceStatus = async (chargerMacId, bearer_token) => {
    const token = bearer_token || SessionManager.getAccessToken();
    if (!token) {
        clearSessionAndRedirect();
        throw new Error('No access token available for getChargerDeviceStatus. User logged out.');
    }
    const url = `${CHARGER_THING_URL}charger:${chargerMacId}/features/deviceStatus/properties`;
    const result = await fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
    });
    if (!result.ok) throw new Error(`HTTP error: ${result.status}`);
    return result.json();
};

/*
 * POST call for: Register User
*/
export const handleRegisterUser = async (type, model, bearer_token,userid='') => {
    let url = USERS_URL;
    model.attributes.type = type;
    let requestOptions = {}
    if(userid !== '') {
        requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + bearer_token
            },
            body: JSON.stringify(model)
        };        
        url += userid;
    } else {
        requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + bearer_token
            },
            body: JSON.stringify(model)
        };
    }
    const result = await fetch(url, requestOptions);
    if ((result.ok) && ((result.status === 204) || (result.status === 201))) {
        return true;
    } else {
        const value = await result.json();
        return result.status === 400 ? ERROR_MSG_500 : value.errorMessage;
    }
}

/*
 * GET call for: getting all users
*/
export const getAllUsers = async (bearer_token) => {
    const url = USERS_URL;
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + bearer_token
        }
    };
    const result = await fetch(url, requestOptions);
    if (!result.ok) {
        throw new Error(`HTTP error: ${result.status}`);
    }
    const value = await result.json();
    return value;
}

/*
 * GET call for: getting all sites
*/
export const getAllSites = async (bearer_token) => {
    const url = DEVICE_URL + '?namespaces=site';
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + bearer_token
        }
    };
    const result = await fetch(url, requestOptions);
    if (!result.ok) {
        throw new Error(`HTTP error: ${result.status}`);
    }
    const value = await result.json();
    return value.items || [];
}

/*
 * Compute next incremental siteId from an existing site list.
 * Returns 1 if list is empty / has no numeric siteIds.
 */
const computeNextSiteId = (existingSites) => {
    const ids = (existingSites || [])
        .map(s => parseInt(s?.attributes?.siteId, 10))
        .filter(n => Number.isFinite(n));
    if (ids.length === 0) return 1;
    return Math.max(...ids) + 1;
}

/*
 * PUT call for: Register a new Site (thing type "site").
 * Generates a unique incremental numeric siteId from existing sites.
 * Single retry on conflict to handle the case where another admin
 * registered a site in parallel.
 */
export const handleRegisterSite = async ({ name, address, city, country }, bearer_token) => {
    const token = bearer_token || SessionManager.getAccessToken();
    if (!token) {
        clearSessionAndRedirect();
        throw new Error('No access token available for handleRegisterSite. User logged out.');
    }
    const decoded = parseJwt(token);
    const policyowner = { userId: decoded.sub, type: decoded.type };

    const attempt = async () => {
        const existing = await getAllSites(token);
        const nextId = computeNextSiteId(existing);
        const identifier = `site:${nextId}`;
        const model = {
            attributes: {
                siteId: String(nextId),
                name,
                address,
                city,
                country,
                status: 'active'
            }
        };
        const result = await handleRegisterThing(identifier, model, token, policyowner);
        return { result, nextId };
    };

    let { result, nextId } = await attempt();
    if (result !== true) {
        // Retry once — another concurrent registration could have taken the ID.
        ({ result, nextId } = await attempt());
    }
    if (result === true) {
        return { ok: true, siteId: String(nextId) };
    }
    return { ok: false, error: result };
}

/*
 * GET call for: getting all subjects, optionally filtered by siteId
*/
export const getAllSubjects = async (bearer_token, siteId = '') => {
    let url = DEVICE_URL + '?namespaces=eCRF_subjects';
    if (siteId) {
        url += '&filter=' + encodeURIComponent(`eq(attributes/siteId,"${siteId}")`);
    }
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + bearer_token
        }
    };
    const result = await fetch(url, requestOptions);
    if (!result.ok) {
        throw new Error(`HTTP error: ${result.status}`);
    }
    const value = await result.json();
    return value.items;
}

/*
 * GET call for: getting all devices
*/
export const getAllDevices = async (bearer_token) => {
    const token = bearer_token || SessionManager.getAccessToken();
    if (!token) {
        clearSessionAndRedirect();
        throw new Error('No access token available for getAllDevices. User logged out.');
    }
    const url = DEVICE_URL + '?namespaces=pacemaker';
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        }
    };
    const result = await fetch(url, requestOptions);
    if (!result.ok) {
        throw new Error(`HTTP error: ${result.status}`);
    }
    const value = await result.json();
    return value.items;
}

/*
 * GET call for: get filtered users
*/
export const getFilteredUsers = async (bearer_token, filter) => {
    const url = USERS_URL + '?search=' + encodeURIComponent(filter);
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + bearer_token
        }
    };
    const result = await fetch(url, requestOptions);
    if (!result.ok) {
        throw new Error(`HTTP error: ${result.status}`);
    }
    const value = await result.json();
    return value;
}

/*
 * GET call for: get filtered devices
*/
export const getFilteredDevices = async (bearer_token, filter) => {
    const url = DEVICE_URL + '?namespaces=pacemaker&filter=' + encodeURIComponent(filter);
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + bearer_token
        }
    };
    const result = await fetch(url, requestOptions);
    if (!result.ok) {
        throw new Error(`HTTP error: ${result.status}`);
    }
    const value = await result.json();
    return value.items;
}

export const handlePolicyInfo = async (bearer_token, policyId) => {
    const token = bearer_token || SessionManager.getAccessToken();
    if (!token) {
        clearSessionAndRedirect();
        throw new Error('No access token available for handlePolicyInfo. User logged out.');
    }
    const url = REGISTER_POLICIES_URL + policyId;
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        }
    };
    const result = await fetch(url, requestOptions);
    if (!result.ok) {
        throw new Error(`HTTP error: ${result.status}`);
    }
    const value = await result.json();
    return value;
}

/*
 * PUT call for: grant policy
*/
export const handleGrantPolicy = async (macId, userId, bearer_token, emailId, type) => {
    const policyId = `pacemaker:${macId}-policy`;
    const thingVal = `calyan:${userId}`;
    const url = REGISTER_POLICIES_URL + policyId + '/entries/' + emailId;
    const subjectVal = {
        [thingVal]:
            {
                "type": type
            }
    }
    grantPolicyModel.subjects = subjectVal;

    const requestOptions = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + bearer_token
        },
        body: JSON.stringify(grantPolicyModel)
    };
    const result = await fetch(url, requestOptions);

    if(result.status === 201) {
        const value = await result.json();
        console.log(value);
        return { status:201, message: "Device assigned"};
    }
    else if(result.status === 204) {
        return { status:204, message: "Device already assigned"}
    }
    else {
        const value = await result.json();
        return result.status === 400 ? {status:400, message: ERROR_MSG_500} :
            {status: result.status,
                message: value.errorMessage?value.errorMessage:"Device can't be assigned"};
    }
}

/*
 * DELETE call for: revoke policy
*/
export const handleRevokePolicy = async (macId, userId, bearer_token, emailId, type) => {
    const policyId = `pacemaker:${macId}-policy`;
    const thingVal = `calyan:${userId}`;
    const url = REGISTER_POLICIES_URL + policyId + '/entries/' + emailId;
    const subjectVal = {
        [thingVal]:
            {
                "type": type
            }
    }
    revokePolicyModel.subjects = subjectVal;

    const requestOptions = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + bearer_token
        },
        body: JSON.stringify(revokePolicyModel)
    };
    const result = await fetch(url, requestOptions);
    return result.status === 204?{ status:204, message: "Device unassigned"}:
        { status:501, message: "Device can't be unassigned"};
}

/*
 * PUT call for: grant policy
*/
export const handleGrantThingPolicy = async (identifier, userId, bearer_token, emailId, type, isRW) => {
    const policyId = `${identifier}-policy`;
    const thingVal = `calyan:${userId}`;
    const url = REGISTER_POLICIES_URL + policyId + '/entries/' + emailId;
    const subjectVal = {
        [thingVal]:
            {
                "type": type
            }
    }
    let policy = {};
    if(isRW) {
        policy = grantPolicyModel;
        policy.subjects = subjectVal;
    } else {
        policy = grantRdonlyPolicyModel;
        policy.subjects = subjectVal;        
    }

    const requestOptions = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + bearer_token
        },
        body: JSON.stringify(policy)
    };
    const result = await fetch(url, requestOptions);

    if(result.status === 201) {
        const value = await result.json();
        console.log(value);
        return { status:201, message: "Device assigned"};
    }
    else if(result.status === 204) {
        return { status:204, message: "Device already assigned"}
    }
    else {
        const value = await result.json();
        return result.status === 400 ? {status:400, message: ERROR_MSG_500} :
            {status: result.status,
                message: value.errorMessage?value.errorMessage:"Device can't be assigned"};
    }
}

/*
 * DELETE call for: revoke policy
*/
export const handleRevokeThingPolicy = async (identifier, userId, bearer_token, emailId, type) => {
    const policyId = `${identifier}-policy`;
    const thingVal = `calyan:${userId}`;
    const url = REGISTER_POLICIES_URL + policyId + '/entries/' + emailId;
    const subjectVal = {
        [thingVal]:
            {
                "type": type
            }
    }
    revokePolicyModel.subjects = subjectVal;

    const requestOptions = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + bearer_token
        },
        body: JSON.stringify(revokePolicyModel)
    };
    const result = await fetch(url, requestOptions);
    return result.status === 204?{ status:204, message: "Device unassigned"}:
        { status:501, message: "Device can't be unassigned"};
}

//#endregion

/**
 * Redirect to Keycloak password reset page
 */
export const redirectToKeycloakPasswordReset = () => {
  // Keycloak's account management password reset URL
  const resetUrl = baseurl + 'auth/realms/calyan/login-actions/reset-credentials?client_id=' + clientID;
  window.location.href = resetUrl;
};


